import storage from 'services/storage'
import {serverPhoneFormat} from 'services/utils/apiUtils'
import baseApi, {
    transformResponseFromData,
    // transformResponseFromMessage,
    // provideTags,
    // provideTag,
} from 'store/slices/api/baseApi'
import qs from 'qs'

const authApi = baseApi.injectEndpoints({
    endpoints: (build) => ({
        getCurrentUser: build.query({
            query: () => ({url: 'Provision/userdetails/', method: 'GET'}),
            transformResponse: transformResponseFromData,
            providesTags: ['CurrentUser'],
        }),
        login: build.mutation({
            query: ({username, password}) => {
                console.log('login mutation req', {username, password})

                const creds = storage.getLoginCredentials()
                const ulth = creds?.ulth || ''
                const passwordString = `password${password}_${ulth}` // `${password}${ulth}`
                return {
                    url: `token`,
                    method: 'POST',
                    //body: `username=${username}&password=${password}${ulth}&grant_type=password`, // {username, password},
                    body: `username=${serverPhoneFormat(
                        username
                    )}&password=${passwordString}&grant_type=password&ulth=${ulth}&organization=my_organization&id=027264100&phone=${serverPhoneFormat(
                        username
                    )}`, // {username, password},
                }
            },
            transformResponse: transformResponseFromData,
            invalidatesTags: ['CurrentUser'],
        }),
        verifySmsMobile: build.mutation({
            query: ({phone, sms}) => {
                return {
                    url: `General/VerificationSMSMobile?loginPhone=${serverPhoneFormat(
                        phone
                    )}&sms=${sms}`,
                    method: 'PUT',
                    // body: `username=${username}&password=${password}&grant_type=password`, // {username, password},
                }
            },
            transformResponse: transformResponseFromData,
            invalidatesTags: ['CurrentUser'],
        }),
        sendSmsForSignup: build.mutation({
            query: ({phone}) => {
                return {
                    url: `General/smsSignUp?${qs.stringify({
                        phone,
                    })}`,
                    method: 'GET',
                }
            },
            transformResponse: transformResponseFromData,
            // invalidatesTags: ['CurrentUser'],
        }),
        verifySmsSignup: build.mutation({
            query: ({phone, sms}) => {
                return {
                    url: `General/verificationSMSSignUp?${qs.stringify({
                        phone,
                        sms,
                    })}`,
                    method: 'PUT',
                    // body: `username=${username}&password=${password}&grant_type=password`, // {username, password},
                }
            },
            transformResponse: transformResponseFromData,
            invalidatesTags: ['CurrentUser'],
        }),

        logout: build.mutation({
            query: () => ({
                url: `auth/logout`,
                method: 'POST',
            }),
            transformResponse: transformResponseFromData,
            invalidatesTags: ['CurrentUser'],
        }),
        signup: build.mutation({
            query: (body) => {
                return {
                    url: 'Provision/createaccountByPhone/',
                    method: 'POST',
                    body,
                }
            },
            transformResponse: transformResponseFromData,
            invalidatesTags: ['CurrentUser'],
        }),
        forgotPassword: build.mutation({
            query: ({phone, password}) => {
                console.log('forgot password mutation req', {phone, password})
                return {
                    url: `Provision/forgotMobilePassword?ph=${serverPhoneFormat(
                        phone
                    )}&ps=${password}`,
                    method: 'POST',
                    body: {ph: phone, ps: password},
                }
            },
            transformResponse: transformResponseFromData,
            invalidatesTags: ['CurrentUser'],
        }),
        resetPassword: build.mutation({
            query: ({password, token}) => {
                console.log('signup mutation req', {password, token})
                return {
                    url: `auth/resetPassword`,
                    method: 'POST',
                    body: {password, token},
                }
            },
            transformResponse: transformResponseFromData,
            invalidatesTags: ['CurrentUser'],
        }),
        deleteUser: build.mutation({
            query: ({accountKey}) => {
                return {
                    url: `Provision/DeleteUserAccount?accountKeyForDelete=${accountKey}`,
                    method: 'DELETE',
                    body: {},
                }
            },
        }),
        verifyOrgCode: build.mutation({
            query: ({orgCode}) => {
                console.log('verifyOrgCode mutation req', orgCode)
                return {
                    url: `Planner/plannerOrgCode?${qs.stringify({
                        orgCode,
                    })}`,
                    method: 'GET',
                }
            },
            transformResponse: transformResponseFromData,
            // invalidatesTags: ['CurrentUser'],

            // /Planner/plannerOrgCode?orgCode=05g2q2y7
        }),
    }),
    overrideExisting: false,
})

export default authApi

export const {
    useLoginMutation,
    useVerifySmsMobileMutation,
    useGetCurrentUserQuery,
    useLogoutMutation,
    useSignupMutation,
    useVerifySmsSignupMutation,
    useForgotPasswordMutation,
    useResetPasswordMutation,
    useSendSmsForSignupMutation,
    useDeleteUserMutation,
    useVerifyOrgCodeMutation,
    // useGetUsersQuery,
    // useGetUserQuery,
    // useGetVersionsQuery,
    // useStatsQuery,
    // useUpdateVersionsMutation,
} = authApi
